var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"history-list-wrapper"},[(_vm.getHistoryState.error.history)?_c('ErrorMessage',{attrs:{"header":_vm.$t('common.error.api'),"content":_vm.$t('common.error.api_content')}}):(_vm.getHistoryState.loading.history)?_c('HistoryLoader'):_c('HistoryTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }